/**
 * @brisa/ui · Card
 *
 * Container com canvas elevado (--brisa-bg-elevated). Heading opcional via prop.
 */
import * as React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  heading?: string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { heading, className, children, role, ...rest },
  ref,
) {
  const classes = ['brisa-card', 'brisa-card--surface', 'brisa-card--verde', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div ref={ref} role={role} className={classes} {...rest}>
      {heading ? <h2 className="brisa-card-heading brisa-display">{heading}</h2> : null}
      <div className="brisa-card-body">{children}</div>
    </div>
  );
});

Card.displayName = 'Card';
